.ux-w-link-item {
    display: inline-block;
    min-width: 248px;
    max-width: 248px;
    padding: 20px 30px;
    position: relative;

    &__inner {
        position: absolute;
        width: calc(100% - 40px);
        left: 0;
        top: 50%;
        right: 0;
        margin: auto;
        transform: translateY(-50%);
        text-align: center;
    }

    &__icon {
        font-size: 95px;
    }

    &__headline {
        @include font(bold);
        color: $color-black;
        margin: 5px 0 15px;
    }
}
